import { useSelector } from 'react-redux';
import { RootState } from '../store';
import {
  BillingIcon,
  DashboardIcon,
  ChatBubble,
  BookOpenIcon,
  FolderFillIcon,
  FormsFilledIcon,
  IconNameToComponent,
  IconType,
} from '../components/Icons';
import { ModuleSettingsItem } from '../constants/dataTypes';

type CoreModule = 'payments' | 'forms' | 'knowledgeBase' | 'files' | 'messages';
const emptyModules: ModuleSettingsItem[] = [];

export const useModuleIcon = (moduleName: CoreModule) => {
  const modules =
    useSelector((state: RootState) => state.settings.moduleSettings) ||
    emptyModules;
  const module = modules.find(m => m.id === moduleName);

  let Icon = IconNameToComponent[module?.icon as IconType];
  if (!Icon) {
    switch (moduleName) {
      case 'payments':
        Icon = BillingIcon;
        break;
      case 'forms':
        Icon = FormsFilledIcon;
        break;
      case 'knowledgeBase':
        Icon = BookOpenIcon;
        break;
      case 'files':
        Icon = FolderFillIcon;
        break;
      case 'messages':
        Icon = ChatBubble;
        break;
      default:
        Icon = DashboardIcon;
    }
  }

  return Icon;
};
